<ng-container
  *ngIf="
    (facilitiesLoaded$ | async) === false && (tenantConfig$ | async) !== undefined && isRouterToIncludeSpinner;
    else appBody
  "
>
  <div id="splash-screen">
    <div id="splash-logo-container">
      <img
        *ngIf="(tenantConfig$ | async) !== undefined"
        id="splash-logo"
        [src]="'./assets/images/logos/logo-' + (tenantConfig$ | async)?.tenantId + '.png'"
        alt="Logo"
      />
    </div>
  </div>
</ng-container>

<ng-template #appBody>
  <router-outlet></router-outlet>
</ng-template>

<!-- BRN-2118 (AC1, AC9): mounted once at the app-shell root (sibling to the router, not inside any
     single route/menu) so the floating launcher/panel persist across SPA navigation. -->
<app-agent-chat-launcher></app-agent-chat-launcher>
<app-agent-chat-panel></app-agent-chat-panel>
